import React, { useMemo } from "react";

export default function SpecialSlide({ rectOptions, props }) {
  const { left, top, height } = rectOptions;
  const { imgWidth, imgHeight, slideWidth, banners, shrinkScale, opacity } =
    props;
  return (
    <div
      style={{
        width: slideWidth,
        height: height,
        position: "absolute",
        overflow: "hidden",
        display: "flex",
        justifyContent: "flex-start",
        transform: `translate(${left}px, ${top}px)`,
      }}
    ></div>
  );
}

// 将原来的 SlideFrame 函数组件改为使用 forwardRef
const SlideFrame = React.forwardRef(
  ({ rectOptions, props, code, subProps = {} }, ref) => {
    const { width, height, left, top } = useMemo(
      () => rectOptions,
      [rectOptions],
    );
    const { opacity = 1 } = useMemo(() => subProps, [subProps]);
    //   const
    const bannerData = useMemo(() => {
      return props.banners?.[0]?.[code - 1] || "";
    }, [props.banners]);
    return (
      <div
        ref={ref} // 将 ref 传递给实际的 DOM 元素
        style={{
          width,
          height,
          opacity,
          position: "absolute",
          transform: `translate(${left}px, ${top}px)`,
        }}
      >
        <img src={bannerData?.imageUrl} alt="" style={{ width, height }} />
      </div>
    );
  },
);

export function Frame1({ rectOptions, props }) {
  const code = 1;
  return (
    <SlideFrame
      rectOptions={rectOptions.subRectOptions[0]}
      props={props}
      code={code}
      subProps={props.subProps[0]}
    />
  );
}
export function Frame2({ rectOptions, props }) {
  const code = 2;
  return (
    <SlideFrame
      rectOptions={rectOptions.subRectOptions[1]}
      subProps={props.subProps[1]}
      props={props}
      code={code}
    />
  );
}
export function Frame3({ rectOptions, props }) {
  const code = 3;
  return (
    <SlideFrame
      rectOptions={rectOptions.subRectOptions[2]}
      subProps={props.subProps[2]}
      props={props}
      code={code}
    />
  );
}

export function HotImage({ rectOptions, props }) {
  return (
    <img
      src={props?.banners?.[0]?.[0]?.hotImageUrl}
      style={{
        width: rectOptions.subRectOptions[3].width,
        height: rectOptions.subRectOptions[3].height,
        position: "absolute",
        display: "block",
        transform: `translate(${rectOptions.subRectOptions[3].left}px, ${rectOptions.subRectOptions[3].top}px)`,
      }}
    />
  );
}

// '0186091c134543fbb36384a8145594f6app_keyEA2756657087E8F37AE85E5C2B75A775methodjingdong.miniapp.mixUserInfotimestamp2023-11-17 11:14:590186091c134543fbb36384a8145594f6'
